module.exports = __webpack_public_path__ + "static/media/login_img2.c1108a4c.jpg";